/**
 * HealthDisclaimer — aviso de salud reutilizable. Dos audiencias:
 *
 *   - "coach":  se muestra al entrenador en la generación con IA. Refuerza que
 *               el plan generado es un BORRADOR que él valida con criterio
 *               profesional. Deja explícito el flujo "profesional-en-el-medio".
 *   - "client": se muestra al cliente final (link público, PDF, app cliente).
 *               Es el recordatorio que exige la política de Google Play
 *               "Health Content and Services": consultar a un profesional de la
 *               salud antes de iniciar el plan.
 *
 * Una sola fuente de verdad para el texto — si Google pide ajustarlo en la
 * apelación, se cambia acá y se propaga a todas las superficies web.
 */
import { Icon } from "./Icon";

export const HEALTH_DISCLAIMER_COACH =
  "Borrador generado por IA. Revísalo y ajústalo con tu criterio profesional antes de entregarlo a tu cliente. AetherLite es una herramienta de apoyo y no sustituye el juicio profesional ni el consejo médico.";

export const HEALTH_DISCLAIMER_CLIENT =
  "Este plan fue elaborado por tu entrenador. Antes de iniciar cualquier programa de ejercicio, nutrición o suplementación, consulta a un profesional de la salud, en especial si tienes condiciones médicas, lesiones, estás en embarazo o tomas medicación.";

interface HealthDisclaimerProps {
  audience: "coach" | "client";
  /** Compacto: sin ícono, fuente más chica — para footers. */
  compact?: boolean;
  style?: React.CSSProperties;
}

export function HealthDisclaimer({ audience, compact, style }: HealthDisclaimerProps) {
  const text =
    audience === "coach" ? HEALTH_DISCLAIMER_COACH : HEALTH_DISCLAIMER_CLIENT;
  return (
    <div
      className={"al-health-disclaimer" + (compact ? " al-health-disclaimer-compact" : "")}
      role="note"
      style={style}
    >
      {!compact && (
        <span className="al-health-disclaimer-icon" aria-hidden="true">
          <Icon name="heart" size={14} />
        </span>
      )}
      <span className="al-health-disclaimer-text">{text}</span>
    </div>
  );
}
